import { render, staticRenderFns } from "./PaxelMarketMainHeader.vue?vue&type=template&id=c02ed9be&"
import script from "./PaxelMarketMainHeader.vue?vue&type=script&lang=js&"
export * from "./PaxelMarketMainHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports